import { toPath } from '../PathGenerator/path-generator'
import { HasKortNavn, traceAll } from './tracer'

type Options = {
  rows: number
  radius: number
  spacing: number // Spacing between circles
  marginHorizontal: number
  marginVertical: number
}

export function traceOutlines<T extends HasKortNavn>(table: T[][], options: Options) {
  return traceAll(table).map(item => ({
    ...item,
    path: toPath(item.moves, options)
  }))
}

export function getClippedLength<T>(table: T[][], options: Options) {
  const { radius, spacing } = options
  const colSize = 2 * radius + spacing
  let columns = table.findIndex(column => column.every(entry => !entry))
  if (columns === -1) {
    columns = table.length
  }

  return columns * colSize + spacing
}

export function calculateSize(options: Options) {
  const { radius, rows, spacing, marginVertical } = options
  const colSize = 2 * radius + spacing
  return rows * colSize - spacing + 2 * marginVertical
}

export function getCircle(col: number, row: number, options: Options) {
  const { radius, spacing, marginHorizontal, marginVertical } = options
  const colwidth = 2 * radius + spacing
  const x = marginHorizontal + radius + col * colwidth
  const y = marginVertical + radius + row * colwidth
  return { x, y, r: radius }
}

export function createSizeCalc(radius, viewWidth, ratio = 1, minVw = 375, vwMultiplier = 0.005) {
  const scalePart = `${vwMultiplier} * ${viewWidth} - ${minVw * vwMultiplier}px`

  return `calc((${radius}px + ${scalePart}) * ${ratio})`
}
